import { Injectable, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

//import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
//import { MomentModule } from 'angular2-moment';
import * as moment from 'moment'; 

// add global variables here
import * as Constants from 'src/app/services/constants/constants';
import { GlobalService } from 'src/app/services/global/global.service';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private consoleLog:boolean = false;

  // approach 1:  https://medium.com/@paulstelzer/ionic-4-the-ultimate-theme-switcher-ab5a592cb1c4
  public renderer:any;

  // approach 2:  https://github.com/fmendoza/SwipeOne
  private currentTheme = '';
  
  constructor
  ( public globalProvider: GlobalService
  , public translate: TranslateService
  , public rendererFactory: RendererFactory2
  , @Inject(DOCUMENT) private document: Document
  ) 
  {
    console.log('themeService.ctor - LifeCycle');
    this.consoleLog = globalProvider.consoleLog_theme;
    this.initializeRenderer();
  }

  // ----------------------------------------------------
  // approach 2:  https://medium.com/@paulstelzer/ionic-4-the-ultimate-theme-switcher-ab5a592cb1c4
  // ----------------------------------------------------
  initializeRenderer()
  {
    if (this.consoleLog) console.log('themeService.initializeRenderer');
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public switchThemeButtonClass(newThemeButtonClass: string):string
  {
    let oldThemeButtonClass:string = this.globalProvider.UserAppConfig.ThemeButtonClass;
    this.removeBodyClass(oldThemeButtonClass);   // 'ambit-theme-original'
    this.addBodyClass(newThemeButtonClass);      // 'ambit-theme-insite'
    this.globalProvider.UserAppConfig.ThemeButtonClass = newThemeButtonClass;

    return newThemeButtonClass;
  }

  addBodyClass(bodyClass) 
  {
    if (this.consoleLog) console.log('themeService.addBodyClass ' + bodyClass);
    this.renderer.addClass(this.document.body, bodyClass);
  }

  removeBodyClass(bodyClass) 
  {
    if (this.consoleLog) console.log('themeService.removeBodyClass ' + bodyClass);
    this.renderer.removeClass(this.document.body, bodyClass);
  }

  /*
  enableDarkMode(enableDarkMode: boolean) 
  {
    if (this.consoleLog) console.log('themeService.enableDarkMode ' + enableDarkMode);
    let theme = this.getCssThemeLight();
    if (enableDarkMode) theme = this.getCssThemeDark();
    this.document.documentElement.style.cssText = theme;
  }
  */

  public enableTheme(ThemeCode: string):string
  {
    if (this.consoleLog) console.log('themeService.enableTheme ' + ThemeCode
               + ' from ' + this.globalProvider.UserAppConfig.ThemeCode);

    let CssTheme;

    // set a default if none is passed or we are initializing
    if ((!ThemeCode) || (ThemeCode === Constants.THEME_INITIAL))
    {
      ThemeCode = this.globalProvider.UserAppConfig.ThemeCode;
    }

    // based on the theme selected, set the appropriate button class (from variables.scss)
    // and then apply some additional theme colors 
    if (ThemeCode === Constants.THEME_INSITE)
    {
      this.switchThemeButtonClass('themebuttonclass-insite');  // see variables.scss
      CssTheme = this.getCssThemeInsite();
    }
    else if (ThemeCode === Constants.THEME_MAXXESS)
    {
      this.switchThemeButtonClass('themebuttonclass-maxxess');  // see variables.scss
      CssTheme = this.getCssThemeMaxxess();
    }
    else if (ThemeCode === Constants.THEME_AMBIT)
    {
      this.switchThemeButtonClass('themebuttonclass-ambit');  // see variables.scss
      CssTheme = this.getCssThemeAmbit();
    }
    else if (ThemeCode === Constants.THEME_DARK)
    {
      this.switchThemeButtonClass('themebuttonclass-ambit');  // see variables.scss
      CssTheme = this.getCssThemeDark();
    }
    else if (ThemeCode === Constants.THEME_LIGHT)
    {
      this.switchThemeButtonClass('themebuttonclass-ambit');  // see variables.scss
      CssTheme = this.getCssThemeLight();
    }
    else if (ThemeCode === Constants.THEME_CRAZY)
    {
      this.switchThemeButtonClass('themebuttonclass-crazy');  // see variables.scss
      CssTheme = this.getCssThemeCrazy();
    }
    else
    {
      console.error('themeService.enableTheme - UNRECOGNIZED THEME: ' + ThemeCode);
      return;
    }

    this.globalProvider.UserAppConfig.ThemeCode = ThemeCode;
    this.document.documentElement.style.cssText = CssTheme;

    return this.globalProvider.UserAppConfig.ThemeCode;
  }

  getCssThemeInsite() 
  {
    return `
      ${this.currentTheme}
      /*
        --ion-background-color: #2f4050;  
        --ion-item-background-color: #2c3a47;
        --ion-text-color: #000000;
        --ion-text-color-step-400: #444444;
        --ion-text-color-step-600: #666666;
        --ion-color-primary: #485dc3;
        --ion-color-secondary: #607d8b;
        --ion-color-tertiary: #e6e6e6;
      */
      --ion-color-mytoolbar: #383a3e;
      --ion-color-mytoolbar-contrast: #f4f5f8;
      --ion-color-myheaderbutton: #f4f5f8;
      --ion-color-myheaderbutton-contrast: #000000;
      --ion-color-mymenuitem: #383a3e;
      --ion-color-mymenuitem-contrast: #D2D3D4;
      --ion-color-mymenudivider: #222428;
      --ion-color-mymenudivider-contrast: #e36b3c;
      --ion-color-mycontentbackground: #222428;
      --ion-color-mycontentbackground-contrast: #D2D3D4;
      --ion-color-mycardheader: #c54f21;
      --ion-color-mycardheader-contrast: #f4f5f8;
      --ion-color-mycardsection: #818386;
      --ion-color-mycardsection-contrast: #fff;
      --ion-color-mycarditem: #f4f5f8;
      --ion-color-mycarditem-contrast: #000000;
      --ion-color-mytitle: #f4f5f8; 
    `;
  }

  getCssThemeMaxxess() 
  {
    return `
      ${this.currentTheme}
      /*
        --ion-background-color: #2f4050;  
        --ion-item-background-color: #2c3a47;
        --ion-text-color: #000000;
        --ion-text-color-step-400: #444444;
        --ion-text-color-step-600: #666666;
        --ion-color-primary: #485dc3;
        --ion-color-secondary: #607d8b;
        --ion-color-tertiary: #e6e6e6;
      */
      --ion-color-mytoolbar: #2c3a47;
      --ion-color-mytoolbar-contrast: #edf1f2;
      --ion-color-myheaderbutton: #edf1f2;
      --ion-color-myheaderbutton-contrast: #000000;
      --ion-color-mymenuitem: #2c3a47;
      --ion-color-mymenuitem-contrast: #00ffff;
      --ion-color-mymenudivider: #111d29;
      --ion-color-mymenudivider-contrast: #edf1f2;
      --ion-color-mycontentbackground: #111d29;
      --ion-color-mycontentbackground-contrast: #edf1f2;
      --ion-color-mycardheader: #2d6b99;
      --ion-color-mycardheader-contrast: #ffffff;
      --ion-color-mycardsection: #607d8b;
      --ion-color-mycardsection-contrast: #ffffff;
      --ion-color-mycarditem: #ffffff;
      --ion-color-mycarditem-contrast: #000000;
      --ion-color-mytitle: #fff; 
    `;
  }

  getCssThemeAmbit() 
  {
    return `
      ${this.currentTheme}
      /*
        --ion-background-color: #c0c0c0;
        --ion-item-background-color: #000000;
        --ion-toolbar-color: #000000;
        --ion-text-color: #fff;
        --ion-text-color-step-400: #fff;
        --ion-text-color-step-600: #fff;
        --ion-color-primary: #485dc3;
        --ion-color-secondary: #008F46;
        --ion-color-tertiary: #c0c0c0;
      */
      --ion-color-mytoolbar: #000000;
      --ion-color-mytoolbar-contrast: #c0c0c0;
      --ion-color-myheaderbutton: #f2f2f2;
      --ion-color-myheaderbutton-contrast: #000000;
      --ion-color-mymenuitem: #202020;
      --ion-color-mymenuitem-contrast: #c0c0c0;
      --ion-color-mymenudivider: #000000;
      --ion-color-mymenudivider-contrast: #808080;
      --ion-color-mycontentbackground: #202020;
      --ion-color-mycontentbackground-contrast: #808080;
      --ion-color-mycardheader: #485dc3;
      --ion-color-mycardheader-contrast: #ffffff;
      --ion-color-mycardsection: #c0c0c0;
      --ion-color-mycardsection-contrast: #000000;
      --ion-color-mycarditem: #ffffff;
      --ion-color-mycarditem-contrast: #000000;
      --ion-color-mytitle: #fff; 
    `;
  }

  getCssThemeDark() 
  {
    return `
      ${this.currentTheme}
      /*
        --ion-background-color: #171717;
        --ion-item-background-color: #171717;
        --ion-toolbar-color: #ff0000;
        --ion-text-color: #fff;
        --ion-text-color-step-400: #fff;
        --ion-text-color-step-600: #fff;
        --ion-color-primary: #3880ff;
        --ion-color-secondary: #0cd1e8;
      */
      --ion-color-mytoolbar: #171717;
      --ion-color-mytoolbar-contrast: #fff;
      --ion-color-myheaderbutton: #ffd700;
      --ion-color-myheaderbutton-contrast: #000000;
      --ion-color-mymenuitem: #171717;
      --ion-color-mymenuitem-contrast: #fff;
      --ion-color-mymenudivider: #1f1f1f;
      --ion-color-mymenudivider-contrast: #e9e9e9;
      --ion-color-mycontentbackground: #000;
      --ion-color-mycontentbackground-contrast: #e9e9e9;
      --ion-color-mycardheader: #555555;
      --ion-color-mycardheader-contrast: #ffffff;
      --ion-color-mycardsection: #c0c0c0;
      --ion-color-mycardsection-contrast: #000000;
      --ion-color-mycarditem: #ffffff;
      --ion-color-mycarditem-contrast: #000000;
      --ion-color-mytitle: #fff; 
    `;
  }

  getCssThemeLight() 
  {
    return `
      ${this.currentTheme}
      /*
        --ion-background-color: #fff;
        --ion-item-background-color: #fff;
        --ion-toolbar-color: #0000ff;
        --ion-text-color: #222;
        --ion-text-color-step-400: #222;
        --ion-text-color-step-600: #222;
        --ion-color-primary: #3880ff;
        --ion-color-secondary: #0cd1e8;
      */
      --ion-color-mytoolbar: #fff;
      --ion-color-mytoolbar-contrast: #000;
      --ion-color-myheaderbutton: #000;
      --ion-color-myheaderbutton-contrast: #fff;
      --ion-color-mymenuitem: #fff;
      --ion-color-mymenuitem-contrast: #000;
      --ion-color-mymenudivider: #eeeeee;
      --ion-color-mymenudivider-contrast: #111111;
      --ion-color-mycontentbackground: #fff;
      --ion-color-mycontentbackground-contrast: #111111;
      --ion-color-mycardheader: #555555;
      --ion-color-mycardheader-contrast: #ffffff;
      --ion-color-mycardsection: #c0c0c0;
      --ion-color-mycardsection-contrast: #000000;
      --ion-color-mycarditem: #ffffff;
      --ion-color-mycarditem-contrast: #000000;
      --ion-color-mytitle: #222; 
    `;
  }

  getCssThemeCrazy() 
  {
    return `
      ${this.currentTheme}
      --ion-color-mytoolbar: #00ff00;
      --ion-color-mytoolbar-contrast: #0000ff;
      --ion-color-myheaderbutton: #ff00ff;
      --ion-color-myheaderbutton-contrast: #000000;
      --ion-color-mytitle: #0000ff; 
      --ion-color-mycontentbackground: #0c0c0c;
      --ion-color-mycontentbackground-contrast: #fff;
      --ion-color-mycardheader: #ff00ff;
      --ion-color-mycardheader-contrast: #ffffff;
      --ion-color-mycardsection: #cc00cc;
      --ion-color-mycardsection-contrast: #000000;
      --ion-color-mycarditem: #ffffff;
      --ion-color-mycarditem-contrast: #000000;
      --ion-background-color: #00ffff;   // don't use this in general as it changes EVERY background
    `;
  }

  // https://angularfirebase.com/lessons/css-variables-in-ionic-4/

  // ----------------------------------------------------
  // approach X:  https://github.com/fmendoza/SwipeOne
  // copied from GitHub
  // ----------------------------------------------------

  setPrimaryColor(color: string) 
  {
    if (this.consoleLog) console.log('themeService.setPrimaryColor ' + color);
    this.setVariable('--ion-color-primary', color);
  }
  setSecondaryColor(color: string) 
  {
    if (this.consoleLog) console.log('themeService.setSecondaryColor ' + color);
    this.setVariable('--ion-color-secondary', color);
  }
  setTertiaryColor(color: string) 
  {
    if (this.consoleLog) console.log('themeService.setTertiaryColor ' + color);
    this.setVariable('--ion-color-tertiary', color);
  }

  setVariable(name: string, value: string) 
  {
    if (this.consoleLog) console.log('themeService.setVariable ' + name + ':' + value);
    this.currentTheme = `${name}: ${value};`;
    this.document.documentElement.style.setProperty(name, value);
  }

}
